var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',[_c('div',{attrs:{"slot":"left_box_content"},slot:"left_box_content"},[_c(_vm.curLeftComponent,{tag:"component"})],1),_c('div',{attrs:{"slot":"right_box_content"},slot:"right_box_content"},[_c(_vm.curRightComponent,{tag:"component"})],1),_c('div',{attrs:{"slot":"bg_map"},slot:"bg_map"},[_c(_vm.curMapComponent,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }